/* eslint-env browser */

import moment from 'moment';
import calendar from 'lib/Calendar';
import auth from 'lib/Auth';
import shallowEqual from 'react-pure-render/shallowEqual';
import 'isomorphic-fetch';
import Cookie from 'tiny-cookie';
import formUrlEncoded from 'form-urlencoded';

import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import reduce from 'lodash/reduce';

export const API_ROOT = window.API_ROOT;
export const SUBDOMAIN = window.SUBDOMAIN;
export const ORGANIZATION = window.ORGANIZATION;
export const FILTERS = window.FILTERS;

export const SET_EVENTS_FILTER = 'SET_EVENTS_FILTER';
export const SET_EVENTS_SEARCH = 'SET_EVENTS_SEARCH';

export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_FAILURE = 'EVENTS_FAILURE';

export const SINGLE_EVENT_REQUEST = 'SINGLE_EVENT_REQUEST';
export const SINGLE_EVENT_SUCCESS = 'SINGLE_EVENT_SUCCESS';
export const SINGLE_EVENT_FAILURE = 'SINGLE_EVENT_FAILURE';

export const EVENT_CONFLICT_CHECK_REQUEST = 'EVENT_CONFLICT_CHECK_REQUEST';
export const EVENT_CONFLICT_CHECK_SUCCESS = 'EVENT_CONFLICT_CHECK_SUCCESS';
export const EVENT_CONFLICT_CHECK_FAILURE = 'EVENT_CONFLICT_CHECK_FAILURE';
export const EVENT_CONFLICT_CHECK_RESET = 'EVENT_CONFLICT_CHECK_RESET';

export const ADD_EVENT_LOAD_REQUEST = 'ADD_EVENT_LOAD_REQUEST';
export const ADD_EVENT_LOAD_SUCCESS = 'ADD_EVENT_LOAD_SUCCESS';
export const ADD_EVENT_LOAD_FAILURE = 'ADD_EVENT_LOAD_FAILURE';

export const ADD_EVENT_ADD_REQUEST = 'ADD_EVENT_ADD_REQUEST';
export const ADD_EVENT_ADD_SUCCESS = 'ADD_EVENT_ADD_SUCCESS';
export const ADD_EVENT_ADD_FAILURE = 'ADD_EVENT_ADD_FAILURE';

export const EDIT_EVENT_LOAD_REQUEST = 'EDIT_EVENT_LOAD_REQUEST';
export const EDIT_EVENT_LOAD_SUCCESS = 'EDIT_EVENT_LOAD_SUCCESS';
export const EDIT_EVENT_LOAD_FAILURE = 'EDIT_EVENT_LOAD_FAILURE';

export const EDIT_EVENT_EDIT_REQUEST = 'EDIT_EVENT_EDIT_REQUEST';
export const EDIT_EVENT_EDIT_SUCCESS = 'EDIT_EVENT_EDIT_SUCCESS';
export const EDIT_EVENT_EDIT_FAILURE = 'EDIT_EVENT_EDIT_FAILURE';

export const INBOX_REQUEST = 'INBOX_REQUEST';
export const INBOX_SUCCESS = 'INBOX_SUCCESS';
export const INBOX_FAILURE = 'INBOX_FAILURE';
export const INBOX_SET_COUNT = 'INBOX_SET_COUNT';
export const INBOX_EVENT_REQUEST = 'INBOX_EVENT_REQUEST';
export const INBOX_EVENT_SUCCESS = 'INBOX_EVENT_SUCCESS';
export const INBOX_EVENT_FAILURE = 'INBOX_EVENT_FAILURE';
export const INBOX_MARK_CHANGE_APPROVED = 'INBOX_MARK_CHANGE_APPROVED';

export const SCHEDULE_LIST_REQUEST = 'SCHEDULE_LIST_REQUEST';
export const SCHEDULE_LIST_SUCCESS = 'SCHEDULE_LIST_SUCCESS';
export const SCHEDULE_LIST_FAILURE = 'SCHEDULE_LIST_FAILURE';

export const SCHEDULE_VIEW_REQUEST = 'SCHEDULE_VIEW_REQUEST';
export const SCHEDULE_VIEW_SUCCESS = 'SCHEDULE_VIEW_SUCCESS';
export const SCHEDULE_VIEW_FAILURE = 'SCHEDULE_VIEW_FAILURE';

export const PAGE_LIST_REQUEST = 'PAGE_LIST_REQUEST';
export const PAGE_LIST_SUCCESS = 'PAGE_LIST_SUCCESS';
export const PAGE_LIST_FAILURE = 'PAGE_LIST_FAILURE';

export const SET_PAGE_LIST_SEARCH = 'SET_PAGE_LIST_SEARCH';

export const PAGE_VIEW_REQUEST = 'PAGE_VIEW_REQUEST';
export const PAGE_VIEW_SUCCESS = 'PAGE_VIEW_SUCCESS';
export const PAGE_VIEW_FAILURE = 'PAGE_VIEW_FAILURE';

export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGIN_VIA_AUTH_REQUEST = 'LOGIN_VIA_AUTH_REQUEST';
export const LOGIN_VIA_AUTH_SUCCESS = 'LOGIN_VIA_AUTH_SUCCESS';
export const LOGIN_VIA_AUTH_FAILURE = 'LOGIN_VIA_AUTH_FAILURE';

export const SET_LOGIN_DATA = 'SET_LOGIN_DATA';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const LOGIN_VALIDATE_REQUEST = 'LOGIN_VALIDATE_REQUEST';
export const LOGIN_VALIDATE_SUCCESS = 'LOGIN_VALIDATE_SUCCESS';
export const LOGIN_VALIDATE_FAILURE = 'LOGIN_VALIDATE_FAILURE';

export const ACTIVATE_LOAD_REQUEST = 'ACTIVATE_LOAD_REQUEST';
export const ACTIVATE_LOAD_SUCCESS = 'ACTIVATE_LOAD_SUCCESS';
export const ACTIVATE_LOAD_FAILURE = 'ACTIVATE_LOAD_FAILURE';

export const ACTIVATE_REQUEST = 'ACTIVATE_REQUEST';
export const ACTIVATE_SUCCESS = 'ACTIVATE_SUCCESS';
export const ACTIVATE_FAILURE = 'ACTIVATE_FAILURE';

export const SETUP_LOAD_REQUEST = 'SETUP_LOAD_REQUEST';
export const SETUP_LOAD_SUCCESS = 'SETUP_LOAD_SUCCESS';
export const SETUP_LOAD_FAILURE = 'SETUP_LOAD_FAILURE';

export const SETUP_REQUEST = 'SETUP_REQUEST';
export const SETUP_SUCCESS = 'SETUP_SUCCESS';
export const SETUP_FAILURE = 'SETUP_FAILURE';

export const CONVERT_LOAD_REQUEST = 'CONVERT_LOAD_REQUEST';
export const CONVERT_LOAD_SUCCESS = 'CONVERT_LOAD_SUCCESS';
export const CONVERT_LOAD_FAILURE = 'CONVERT_LOAD_FAILURE';

export const CONVERT_REQUEST = 'CONVERT_REQUEST';
export const CONVERT_SUCCESS = 'CONVERT_SUCCESS';
export const CONVERT_FAILURE = 'CONVERT_FAILURE';

export const SIGNUP_LOAD_REQUEST = 'SIGNUP_LOAD_REQUEST';
export const SIGNUP_LOAD_SUCCESS = 'SIGNUP_LOAD_SUCCESS';
export const SIGNUP_LOAD_FAILURE = 'SIGNUP_LOAD_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const SEARCH_DATA_REQUEST = 'SEARCH_DATA_REQUEST';
export const SEARCH_DATA_SUCCESS = 'SEARCH_DATA_SUCCESS';
export const SEARCH_DATA_FAILURE = 'SEARCH_DATA_FAILURE';

export const SUBSECTION_NUMBER_REQUEST = 'SUBSECTION_NUMBER_REQUEST';
export const SUBSECTION_NUMBER_SUCCESS = 'SUBSECTION_NUMBER_SUCCESS';
export const SUBSECTION_NUMBER_FAILURE = 'SUBSECTION_NUMBER_FAILURE';

export const DATA_GROUP_REQUEST = 'DATA_GROUP_REQUEST';
export const DATA_GROUP_SUCCESS = 'DATA_GROUP_SUCCESS';
export const DATA_GROUP_FAILURE = 'DATA_GROUP_FAILURE';

export const DATA_GROUP_ITEM_SELECTED = 'DATA_GROUP_ITEM_SELECTED';
export const DATA_GROUP_ITEM_UNSELECT = 'DATA_GROUP_ITEM_UNSELECT';
export const DATA_GROUP_RESET_SELECTED = 'DATA_GROUP_RESET_SELECTED';
export const DATA_GROUP_RESET_SEARCH = 'DATA_GROUP_RESET_SEARCH';
export const DATA_GROUP_RESET_ALL = 'DATA_GROUP_RESET_ALL';
export const DATA_GROUP_SET_SELECTED = 'DATA_GROUP_SET_SELECTED';

export const SET_HEADER = 'SET_HEADER';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const REMOVE_ERROR_MESSAGE = 'REMOVE_ERROR_MESSAGE';

export const FLASH_MESSAGE = 'FLASH_MESSAGE';
export const REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE';

export const ROUTER_DID_CHANGE = '@@reduxReactRouter/routerDidChange';
export const ROUTER_RECORD_BACK = 'ROUTER_RECORD_BACK';

export const NAVIGATION_SHOW = 'NAVIGATION_SHOW';
export const NAVIGATION_HIDE = 'NAVIGATION_HIDE';

export const MODAL_VISIBLE = 'MODAL_VISIBLE';
export const MODAL_HIDDEN = 'MODAL_HIDDEN';

export const MY_TRIPS_REQUEST = 'MY_TRIPS_REQUEST';
export const MY_TRIPS_SUCCESS = 'MY_TRIPS_SUCCESS';
export const MY_TRIPS_FAILURE = 'MY_TRIPS_FAILURE';

export const CACHE_API_RESPONSE = 'CACHE_API_RESPONSE';

// Dummy action, action shouldn't ever be handled
export const NULL_ACTION = 'NULL_ACTION';

export function apiFetch(url, includeAuth, postData, allowCookies) {
  if( typeof allowCookies == 'undefined' ) var allowCookies = false;
  let fetchUrl = url;
  if (includeAuth) {
    fetchUrl = auth.getAuthURL(fetchUrl);
  }

  let options = {
    method: 'get',
  };

  if (postData) {
    options = {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      },
      body: formUrlEncoded(postData),
    };
  }

  if(allowCookies) {
    options = { ...options, credentials: 'include' };
  }

  return fetch(fetchUrl, options)
    .then(response =>
      response.json().then(json => ({ json, response }))
    ).then(({ json, response }) => {
      if (!response.ok || json.error) {
        const rejectJson = json;
        rejectJson.status = response.status;
        return Promise.reject(rejectJson);
      }

      if (json.stored && json.stored !== true) {
        const reformatted = json.stored;
        if (json.metadata) {
          reformatted.metadata = json.metadata;
        }
        return reformatted;
      }

      return json;
    });
}

export function initLoginState(email = '', rememberMe = false) {
  return {
    type: LOGIN_INIT,
    email,
    rememberMe,
  };
}

export function setInboxCount(count) {
  return {
    type: INBOX_SET_COUNT,
    payload: { count },
  };
}

export function populateAuthStatus() {
  const url = `${API_ROOT}?type=ajax&action=login`;
  return {
    types: [LOGIN_VALIDATE_REQUEST, LOGIN_VALIDATE_SUCCESS, LOGIN_VALIDATE_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true),
    shouldCallAPI: () => true,
    payload: {},
    onSuccess: (response, dispatch) => {
      handleAuthReponse(response, dispatch, false, false);
    },
  };
}

export function validateLoginState(authToken, userId, onSuccess, onError) {
  const url = `${API_ROOT}?type=ajax&action=login&user_id=${userId}&user_auth_token=${authToken}`;
  return {
    types: [LOGIN_VALIDATE_REQUEST, LOGIN_VALIDATE_SUCCESS, LOGIN_VALIDATE_FAILURE],
    id: url,
    callAPI: () => apiFetch(url),
    shouldCallAPI: () => true,
    payload: { authToken, userId },
    onSuccess,
    onError,
  };
}

function handleAuthReponse(response, dispatch, processAuthToken, rememberMe) {
  
  if (processAuthToken && response.auth_token) {
    if (!rememberMe) {
      Cookie.set('auth_token', response.auth_token);
      Cookie.set('user_id', response.user_id);
    } else {
      window.persistStore.setItem('auth_token', response.auth_token);
      window.persistStore.setItem('user_id', response.user_id);
      window.persistStore.setItem('email', response.email);
    }
  }

  if (has(response, 'num_undecided')) {
    if (has(response, 'num_undecided.all')) {
      dispatch(setInboxCount(response.num_undecided.all));
    } else if (has(response, 'num_undecided.1')) {
      if (has(response, 'num_undecided.2')) {
        dispatch(setInboxCount(response.num_undecided[1] + response.num_undecided[2]));
      } else {
        dispatch(setInboxCount(response.num_undecided[1]));
      }
    } else if (has(response, 'num_undecided.2')) {
      dispatch(setInboxCount(response.num_undecided[2]));
    }
  }

  if(typeof window.LOGIN == 'undefined') {
    window.LOGIN = {};
  }

  if (has(response, 'admin')) window.LOGIN.admin = response.admin;
  if (has(response, 'school_pref')) window.LOGIN.school_pref = response.school_pref;
  if (has(response, 'nav_menu')) window.LOGIN.nav_menu = response.nav_menu;
  if (has(response, 'login_type')) window.LOGIN.login_type = response.login_type;
  if (has(response, 'type')) window.LOGIN.type = response.type;
  if (has(response, 'picture')) window.LOGIN.picture = response.picture;
  if (has(response, 'primary_group')) window.LOGIN.primary_group = response.primary_group;
  if (has(response, 'user_group')) window.LOGIN.user_group = response.user_group;
  if (has(response, 'user_viewing_groups')) window.LOGIN.user_viewing_groups = response.user_viewing_groups;
  if (has(response, 'show_news')) window.LOGIN.show_news = response.show_news;
  if (has(response, 'caldays_stick')) window.LOGIN.caldays_stick = response.caldays_stick;
  if (has(response, 'caldays')) window.LOGIN.caldays = response.caldays;
  if (has(response, 'plus_minus_time_modifier')) window.LOGIN.plus_minus_time_modifier = response.plus_minus_time_modifier;
  if (has(response, 'calendar_time_delimeter')) window.LOGIN.calendar_time_delimeter = response.calendar_time_delimeter;
  if (has(response, 'time_minute_increments')) window.LOGIN.time_minute_increments = response.time_minute_increments;
  if (has(response, 'view_all_events')) window.LOGIN.view_all_events = response.view_all_events;
  if (has(response, 'primary_event_time')) window.LOGIN.primary_event_time = response.primary_event_time;
  if (has(response, 'records_per_page')) window.LOGIN.records_per_page = response.records_per_page;
  if (has(response, 'tooltip_help')) window.LOGIN.tooltip_help = response.tooltip_help;
  if (has(response, 'code_revision')) window.LOGIN.code_revision = response.code_revision;
  if (has(response, 'user_notification_number')) window.LOGIN.user_notification_number = response.user_notification_number;
  if (has(response, 'email_updates')) window.LOGIN.email_updates = response.email_updates;
  if (has(response, 'sms_updates')) window.LOGIN.sms_updates = response.sms_updates;
  if (has(response, 'email_reminders')) window.LOGIN.email_reminders = response.email_reminders;
  if (has(response, 'sms_reminders')) window.LOGIN.sms_reminders = response.sms_reminders;
  if (has(response, 'default_location')) window.LOGIN.default_location = response.default_location;
  if (has(response, 'trip_list_details')) window.LOGIN.trip_list_details = response.trip_list_details;
  if (has(response, 'trip_list_time')) window.LOGIN.trip_list_time = response.trip_list_time;
  if (has(response, 'trip_list_default_sort')) window.LOGIN.trip_list_default_sort = response.trip_list_default_sort;

  if (has(response, 'notification_groups')) window.LOGIN.notification_groups = response.notification_groups;
  if (has(response, 'user_type')) window.LOGIN.user_type = response.user_type;

  if (has(response, 'driver')) window.LOGIN.driver = response.driver;
  if (has(response, 'secondary_driver')) window.LOGIN.secondary_driver = response.secondary_driver;

  if (has(response, 'role_objects')) window.LOGIN.role_objects = response.role_objects;

  if (has(response, 'has_bills')) window.LOGIN.has_bills = response.has_bills;

  if (has(response, 'new_updates')) window.LOGIN.new_updates = response.new_updates;
  if (has(response, 'new_notifications')) window.LOGIN.new_notifications = response.new_notifications;

  if (has(response, 'disable_inbox')) window.LOGIN.disable_inbox = response.disable_inbox;
  if (has(response, 'disable_new_dashboard')) window.LOGIN.disable_new_dashboard = response.disable_new_dashboard;
  if (has(response, 'disable_dashboard')) window.LOGIN.disable_dashboard = response.disable_dashboard;

  if (has(response, 'verified')) window.LOGIN.verified = response.verified;

  if (has(response, 'last_updated')) window.LOGIN.last_updated = response.last_updated;

  if (has(response, 'prefs')) {

    if(typeof window.LOGIN.prefs == 'undefined') {
      window.LOGIN.prefs = {};
    }

    window.LOGIN.prefs = response.prefs;
  }

  if (has(response, 'permissions')) {

    if(typeof window.LOGIN.permissions == 'undefined') {
      window.LOGIN.permissions = {};
    }

    window.LOGIN.permissions = response.permissions;
  }

  if (has(response, 'roles')) {

    if(typeof window.LOGIN.roles == 'undefined') {
      window.LOGIN.roles = {};
    }

    window.LOGIN.roles = response.roles;
  }

}

export function loginWithAuthToken(authToken, userId, onSuccess, onError) {
  const url = `${API_ROOT}?type=ajax&action=login&user_id=${userId}&user_auth_token=${authToken}`;
  return {
    types: [LOGIN_VIA_AUTH_REQUEST, LOGIN_VIA_AUTH_SUCCESS, LOGIN_VIA_AUTH_FAILURE],
    id: url,
    callAPI: () => apiFetch(url),
    shouldCallAPI: () => true,
    payload: { authToken, userId },
    onSuccess: (response, dispatch) => {
      handleAuthReponse(response, dispatch, true, true);
      return onSuccess && onSuccess(response, dispatch);
    },
    onError: (error, dispatch) => {
      window.persistStore.removeItem('auth_token');
      window.persistStore.removeItem('user_id');
      return onError && onError(error, dispatch);
    },
  };
}

export function login(email, password, rememberMe) {
  const url = `${API_ROOT}?type=ajax&action=login&email=${email}&password=${password}`;
  window.persistStore.setItem('rememberMe', rememberMe);

  return {
    types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
    id: url,
    callAPI: () => apiFetch(url),
    shouldCallAPI: () => true,
    payload: { email, password, rememberMe },
    onSuccess: (response, dispatch) => {
      handleAuthReponse(response, dispatch, true, rememberMe);
    },
    onError: (error, dispatch) => window.persistStore.removeItem('auth_token') && window.persistStore.removeItem('user_id'),
  };
}

export function logout() {
  // @TODO when 'logoff' API update to accept auth token, call API to invalidate token

  // const url = `${API_ROOT}?type=ajax&action=logoff}`;
  window.persistStore.removeItem('auth_token');
  window.persistStore.removeItem('user_id');
  Cookie.set('auth_token', '', { expires: 0 });
  Cookie.set('user_id', '', { expires: 0 });

  return {
    type: LOGOUT_SUCCESS,
  };
}

export function setLoginData(data) {
  return {
    type: SET_LOGIN_DATA,
    payload: data,
  };
}

export function loadActivate(id, code, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=activation&id=${id}&activation_code=${code}&json=t`;

  return {
    types: [ACTIVATE_LOAD_REQUEST, ACTIVATE_LOAD_SUCCESS, ACTIVATE_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false),
    payload: { id, code },
    onSuccess,
    onError,
  };
}

export function activateUser(id, code, data, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=activation&id=${id}&activation_code=${code}&page=2&json=t`;

  return {
    types: [ACTIVATE_REQUEST, ACTIVATE_SUCCESS, ACTIVATE_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false, data),
    payload: { id, code, data },
    onSuccess: (response, dispatch) => {
      handleAuthReponse(response, dispatch, true, true);
      dispatch(setLoginData(response));
      return onSuccess && onSuccess(response, dispatch);
    },
    onError,
  };
}

export function loadSetup(page_type, state_string, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=${page_type}_setup&state_string=${state_string}&json=t`;

  return {
    types: [SETUP_LOAD_REQUEST, SETUP_LOAD_SUCCESS, SETUP_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false),
    payload: { page_type, state_string },
    onSuccess,
    onError,
  };
}

export function setupUser(page_type, state_string, data, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=${page_type}_setup&state_string=${state_string}&page=2&json=t`;

  return {
    types: [SETUP_REQUEST, SETUP_SUCCESS, SETUP_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false, data),
    payload: { page_type, state_string, data },
    onSuccess: (response, dispatch) => {

      if(response.action == 'convert') {

      } else {
        handleAuthReponse(response, dispatch, true, true);
        dispatch(setLoginData(response));
      }

      return onSuccess && onSuccess(response, dispatch);
    },
    onError,
  };
}

export function loadConvert(page_type, state_string, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=${page_type}_convert&state_string=${state_string}&json=t`;

  return {
    types: [CONVERT_LOAD_REQUEST, CONVERT_LOAD_SUCCESS, CONVERT_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false),
    payload: { page_type, state_string },
    onSuccess,
    onError,
  };
}

export function convertUser(page_type, state_string, data, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=${page_type}_convert&state_string=${state_string}&page=2&json=t`;

  return {
    types: [CONVERT_REQUEST, CONVERT_SUCCESS, CONVERT_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false, data),
    payload: { page_type, state_string, data },
    onSuccess: (response, dispatch) => {
      handleAuthReponse(response, dispatch, true, true);
      dispatch(setLoginData(response));
      return onSuccess && onSuccess(response, dispatch);
    },
    onError,
  };
}

export function loadSignUp(onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=sign_up&json=t`;

  return {
    types: [SIGNUP_LOAD_REQUEST, SIGNUP_LOAD_SUCCESS, SIGNUP_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false, null, true),
    onSuccess,
    onError,
  };
}

export function signUpUser(data, onSuccess, onError) {
  const url = `${API_ROOT}?type=user_accounts&action=sign_up&page=2&json=t`;

  return {
    types: [SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, false, data, true),
    payload: { data },
    onSuccess: (response, dispatch) => {
      //handleAuthReponse(response, dispatch, true, true);
      //dispatch(setLoginData(response));
      return onSuccess && onSuccess(response, dispatch);
    },
    onError,
  };
}

export function loadAddEventBase(config) {
  const url = `${API_ROOT}?type=event&action=add&json=t`;

  return {
    types: [ADD_EVENT_LOAD_REQUEST, ADD_EVENT_LOAD_SUCCESS, ADD_EVENT_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true),
    onSuccess: (response, dispatch) => {
      if (config.onSuccess) {
        config.onSuccess(response, dispatch);
      }
    },
    onError: (error, dispatch) => {
      if (config.onError) {
        config.onError(error, dispatch);
      }
    },
  };
}

export function loadEventForEdit(id, config) {
  const url = `${API_ROOT}?type=event&action=edit&id=${id}&json=t`;

  return {
    types: [EDIT_EVENT_LOAD_REQUEST, EDIT_EVENT_LOAD_SUCCESS, EDIT_EVENT_LOAD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true),
    onSuccess: (response, dispatch) => {
      if (config.onSuccess) {
        config.onSuccess(response, dispatch);
      }
    },
    onError: (error, dispatch) => {
      if (config.onError) {
        config.onError(error, dispatch);
      }
    },
    payload: { id },
  };
}

function removePrefixes(prefixes) {
  const noPrefixes = [];

  if (prefixes) {
    const splitPrefixes = prefixes.split(',');

    splitPrefixes.forEach((prefixedId) => {
      if (!isEmpty(prefixedId) && isString(prefixedId)) {
        const parts = prefixedId.split('_');
        noPrefixes.push(parts[1]);
      }
    });
  }

  return noPrefixes.join(',');
}

function getPostFieldsToProcessEvent(event, isConflictCheck = false, includeEquipmentQuantities = false) {
  const post = {
    name: event.name,
    description: event.description,
    date_start: moment(event.date_start).format('YYYY-MM-DD'),
    all_day_checkbox: event.all_day ? 't' : 'f',
    hidden_locations: event.hidden_locations,
    hidden_schools: event.hidden_schools,
    hidden_equipment: event.hidden_equipment,
    hidden_groups: event.hidden_groups,
  };

  const timeFormat = calendar.getTimeMomentFormat();

  const timeStart = moment(event.time_start, ['HH:mm', 'h:mm a']);
  const timeEnd = moment(event.time_end, ['HH:mm', 'h:mm a']);
  const timeSetup = moment(event.time_setup, ['HH:mm', 'h:mm a']);
  const timeBreakdown = moment(event.time_breakdown, ['HH:mm', 'h:mm a']);

  if (timeStart.isValid()) {
    post.time_start = timeStart.format(timeFormat);
  }

  if (timeEnd.isValid()) {
    post.time_end = timeEnd.format(timeFormat);
  }

  if (event.has_setup_breakdown) {
    if (timeSetup.isValid()) {
      post.time_setup = timeSetup.format(timeFormat);
    }

    if (timeBreakdown.isValid()) {
      post.time_breakdown = timeBreakdown.format(timeFormat);
    }
  } else {
    post.time_setup = '';
    post.time_breakdown = '';
  }

  if (event.date_end) {
    post.date_end = moment(event.date_end).format('YYYY-MM-DD');
  }

  if (event.override_conflicts) {
    post.override_conflicts = event.override_conflicts;
  }

  if (isConflictCheck) {
    if (event.groups) {
      post.groups = event.groups;
    }

    if (includeEquipmentQuantities) {
      post.equipment = '';
    } else {
      post.equipment = event.hidden_equipment;
    }
  }

  Object.keys(event).forEach((k) => {
    if (k.indexOf('equipment_quantity_') === 0) {
      post[k] = event[k];

      // conflict check needs equipment in a different format
      if (isConflictCheck && includeEquipmentQuantities) {
        if (post.equipment > '') {
          post.equipment = `${post.equipment},`;
        }
        const id = k.replace('equipment_quantity_', '');
        post.equipment = `${post.equipment}${id}_${post[k]}`;
      }
    } else if (k.indexOf('home_away_neutral_') === 0 && !isConflictCheck) {
      post[k] = event[k];
    } else if (k.indexOf('time_dismiss_') === 0 && !isConflictCheck) {
      post[k] = event[k];
    }
  });

  if (event.private) {
    
    if (event.config.simple_privacy !== '1') {
      if(event.user_viewing_groups) {
        post.toggle_viewing_groups = 'private';
        post.user_viewing_groups = event.user_viewing_groups.join(',');
      } else {
        post.toggle_viewing_groups = 'public';
      }
    } else {
      post.private = event.private;
    }
  }

  if (event.config.require_department === '1') {
    post.hidden_departments = removePrefixes(event.hidden_departments);
  }

  if (event.config.require_activity === '1') {
    post.hidden_activities = removePrefixes(event.hidden_activities);
  }

  if (event.config.require_event_type === '1') {
    post.hidden_event_types = removePrefixes(event.hidden_event_types);
  }

  if (window.CONFIG.enable_event_virtual_meeting_link === '1') {
    if(event.virtual_meeting_link) post.virtual_meeting_link = event.virtual_meeting_link;
    else post.virtual_meeting_link = '';
  }


  return post;
}

export function dataGroupItemSelected(section, subsection, item, prefixedParentId, displayType) {
  return {
    type: DATA_GROUP_ITEM_SELECTED,
    payload: {
      section,
      subsection,
      item,
      prefixedParentId,
      displayType,
    },
  };
}

export function dataGroupItemUnselect(section, subsection, item, prefixedParentId, displayType) {
  return {
    type: DATA_GROUP_ITEM_UNSELECT,
    payload: {
      section,
      subsection,
      item,
      prefixedParentId,
      displayType,
    },
  };
}

export function dataGroupResetSelected(section, subsection) {
  return {
    type: DATA_GROUP_RESET_SELECTED,
    payload: {
      section,
      subsection,
    },
  };
}

export function dataGroupResetSearch(section, subsection) {
  return {
    type: DATA_GROUP_RESET_SEARCH,
    payload: {
      section,
      subsection,
    },
  };
}

export function dataGroupResetAll() {
  return {
    type: DATA_GROUP_RESET_ALL
  };
}

export function dataGroupSetSelected(section, subsection, defaultSelected) {
  return {
    type: DATA_GROUP_SET_SELECTED,
    payload: {
      section,
      subsection,
      defaultSelected,
    },
  };
}

export function getSearchData(section, subsection, config, search, eventId = null) {
  const wizardAction = eventId === null ? 'add' : 'edit';

  // console.log('getSearchData', section, subsection, search, eventId);

  const payload = {
    action: 'get_search_data',
    wizard_action: wizardAction,
    wizard_id: 'tfs_Event;events',
    wizard_type: 'object',
    section,
    data: search,
    ui_version: '22',
    api_version: '3',
    get_recommendations: '0',
    use_id_prefixes: '1',
    use_meta_filters: '0',
  };

  if (config.subsections_search && config.subsections_search.length > 0) {
    payload.subsections = config.subsections_search.join(',');
  } else {
    payload.subsections = config.subsections.join(',');
  }

  if (config.subsections_hierarchy && config.subsections_hierarchy.length > 0) {
    payload.subsection_hierarchy = config.subsections_hierarchy.join(',');
  }

  if (config.additional_fields && config.additional_fields.length > 0) {
    payload.additional_fields = config.additional_fields;
  }

  if (config.subsections_disabled && config.subsections_disabled.length > 0) {
    payload.subsection_disabled = config.subsections_disabled.join(',');
  }

  if (config.subsections_disabled_always_show && config.subsections_disabled_always_show.length > 0) {
    payload.subsection_disabled_always_show = config.subsections_disabled_always_show.join(',');
  }

  // selected_ids=

  if (eventId !== null) {
    payload.object_id = eventId;
  }

  const url = reduce(payload, (result, value, key) => `${result}&${key}=${value}`, `${API_ROOT}?type=ajax`);

  return {
    types: [SEARCH_DATA_REQUEST, SEARCH_DATA_SUCCESS, SEARCH_DATA_FAILURE],
    callAPI: () => apiFetch(url, true),
    payload,
  };
}

export function getSubsectionNumber(section, subsection = null, config = null, eventId = null) {
  const wizardAction = eventId === null ? 'add' : 'edit';

  // console.log('getSubsectionNumber', section, subsection, eventId);

  const payload = {
    action: 'get_subsection_number',
    wizard_action: wizardAction,
    wizard_id: 'tfs_Event;events',
    wizard_type: 'object',
    section,
    ui_version: '22',
    hierarchy: 'false',
    disabled: 'false',
    disabled_always_show: 'false',
    get_recommendations: '0',
    use_id_prefixes: '1',
    use_meta_filters: '0',
    limit: '0',
  };

  if (subsection !== null) {
    payload.subsection = subsection;

    if (config.subsections_hierarchy && config.subsections_hierarchy.length > 0) {
      if (config.subsections_hierarchy.indexOf(subsection) >= 0) {
        payload.hierarchy = 'true';
      }
    }

    if (config.subsections_disabled && config.subsections_disabled.length > 0) {
      if (config.subsections_disabled.indexOf(subsection) >= 0) {
        payload.disabled = 'true';
      }
    }

    if (config.subsections_disabled_always_show && config.subsections_disabled_always_show.length > 0) {
      if (config.subsections_disabled_always_show.indexOf(subsection) >= 0) {
        payload.disabled_always_show = 'true';
      }
    }
  }

  payload.all_subsections = config.subsections.join(',');

  if (config.additional_fields && config.additional_fields.length > 0) {
    payload.additional_fields = config.additional_fields;
  }

  // selected_ids=

  if (eventId !== null) {
    payload.object_id = eventId;
  }

  const url = reduce(payload, (result, value, key) => `${result}&${key}=${value}`, `${API_ROOT}?type=ajax`);

  return {
    types: [SUBSECTION_NUMBER_REQUEST, SUBSECTION_NUMBER_SUCCESS, SUBSECTION_NUMBER_FAILURE],
    callAPI: () => apiFetch(url, true),
    payload,
  };
}

export function getDataGroup(section, subsection, config, parentId, group = null, eventId = null, parentSubsection = null) {
  const wizardAction = eventId === null ? 'add' : 'edit';
  const mainSubsection = subsection;
  group = group === null ? 'all' : group;

  // console.log('getDataGroup', section, subsection, parentId, group, eventId);

  // if (parentId) {
  //   if(subsection == 'school_remote_facility') {
  //     subsection = 'remote_facility';
  //   } else if(subsection == 'school_group_school_restricted') {
  //     subsection = 'school_group_restricted';
  //   } else if(subsection == 'community_group_school_restricted') {
  //     subsection = 'community_group_restricted';
  //   }
  // }

  const payload = {
    action: 'get_data_group',
    wizard_action: wizardAction,
    wizard_id: 'tfs_Event;events',
    wizard_type: 'object',
    section,
    subsection,
    ui_version: '22',
    hierarchy: 'false',
    disabled: 'false',
    disabled_always_show: 'false',
    get_recommendations: '0',
    use_id_prefixes: '1',
    use_meta_filters: '0',
    group,
  };

  if (parentId) {
    payload.parent_id = parentId;
    if(parentSubsection) {
      subsection = parentSubsection;
      payload.subsection = parentSubsection;
    }
  }

  payload.all_subsections = config.subsections.join(',');

  if (config.additional_fields && config.additional_fields.length > 0) {
    payload.additional_fields = config.additional_fields;
  }

  if (config.subsections_hierarchy && config.subsections_hierarchy.length > 0) {
    if (config.subsections_hierarchy.indexOf(subsection) >= 0) {
      payload.hierarchy = 'true';
    }
  }

  if (config.subsections_disabled && config.subsections_disabled.length > 0) {
    if (config.subsections_disabled.indexOf(subsection) >= 0) {
      payload.disabled = 'true';
    }
  }

  if (config.subsections_disabled_always_show && config.subsections_disabled_always_show.length > 0) {
    if (config.subsections_disabled_always_show.indexOf(subsection) >= 0) {
      payload.disabled_always_show = 'true';
    }
  }

  // selected_ids=

  if (eventId !== null) {
    payload.object_id = eventId;
  }

  const url = reduce(payload, (result, value, key) => `${result}&${key}=${value}`, `${API_ROOT}?type=ajax`);

  payload.mainSubsection = mainSubsection;

  return {
    types: [DATA_GROUP_REQUEST, DATA_GROUP_SUCCESS, DATA_GROUP_FAILURE],
    callAPI: () => apiFetch(url, true),
    payload,
  };
}

export function addEvent(event, onSuccess, onError) {
  const url = `${API_ROOT}?type=event&action=add&json=t&page=2`;
  const post = getPostFieldsToProcessEvent(event);

  return {
    types: [ADD_EVENT_ADD_REQUEST, ADD_EVENT_ADD_SUCCESS, ADD_EVENT_ADD_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true, post),
    payload: { event },
    onSuccess,
    onError,
  };
}

export function updateEvent(event, onSuccess, onError) {
  const url = `${API_ROOT}?type=event&action=edit&id=${event.id}&json=t&page=2`;
  const post = getPostFieldsToProcessEvent(event);

  return {
    types: [EDIT_EVENT_EDIT_REQUEST, EDIT_EVENT_EDIT_SUCCESS, EDIT_EVENT_EDIT_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true, post),
    payload: { event },
    onSuccess,
    onError,
  };
}

export function loadEvent(id, forceRefresh = false) {
  const url = `${API_ROOT}?type=view&action=event&id=${id}&json=t`;

  return {
    types: [SINGLE_EVENT_REQUEST, SINGLE_EVENT_SUCCESS, SINGLE_EVENT_FAILURE],
    id: url,
    callAPI: () => apiFetch(url, true),
    shouldCallAPI: (store, dispatch) => {
      if (forceRefresh) {
        return true;
      }

      const cached = store.calendar.events.all[id];
      if (cached && !shallowEqual({}, cached)) {
        // Return from the cache but still go out and fetch an update
        dispatch(loadEvent(id, true));
        return false;
      }
      return true;
    },
    payload: { id },
  };
}

export function loadEvents(view = 'week', filter = {}, search) {
  // @TODO it appears the calling calendar view is expecting filter to be modified by reference incorrectly
  // I had changed this to const formattedFilter and navigation broke. It appears to be related to filter being
  // modified by reference. Need to refactor calling code to get this filter correctly
  /* eslint no-param-reassign: 0 */
  filter = Object.assign(calendar.filterFromMoment(moment()), filter);
  const { month, day, year } = filter;
  let fields = 'id,name,date_start,date_end,time_start,time_end,type,status,home_away';
  if(view == 'year') fields += ',modified,calendar_year,special';
  else fields += ',locations,description';
  let url = `${API_ROOT}?type=view&action=${view}&json=t&fields=${fields}`;
  if(SUBDOMAIN.length > 0) url = `${url}&subdomain=${SUBDOMAIN}`;
  if(ORGANIZATION.length > 0) url = `${url}&organization=${ORGANIZATION}`;
  if(view == 'year') url = `${url}&year=${year}`;
  else url = `${url}&cur_day=${day}&cur_month=${month}&cur_year=${year}`;

  if(typeof FILTERS == 'object') {
    for(let filter in FILTERS) {
      if(typeof filter == 'string' && filter.length > 0) {
        if(filter != 'filter_name' && filter != 'exclude_name') {
          if(typeof FILTERS[filter] == 'string' || typeof FILTERS[filter] == 'number') {
            url += `&${filter}=${FILTERS[filter]}`;
          } else if(typeof FILTERS[filter] == 'array') {
            url += `&${filter}=${FILTERS[filter].join(',')}`;
          }
        }
      }
    }
  }

  if (!isEmpty(search)) {
    url += `&search=${search}`;
  }

  return {
    types: [EVENTS_REQUEST, EVENTS_SUCCESS, EVENTS_FAILURE],
    id: url,
    callAPI: (state) => {
      if (isEmpty(search) && !isEmpty(state.calendar.search)) {
        url += `&search=${state.calendar.search}`;
      } else if (isEmpty(search) && isEmpty(state.calendar.search)) {
        url += `&clear_search=1`;
      }
      return apiFetch(url, true);
    },
    payload: { view, filter, search },
    cacheable: true,
  };
}

export function checkEventConflicts(event, checkFacilities = true, checkGroups = true, checkEquipment = true, checkEquipmentQuantities = false) {
  let url = `${API_ROOT}?action=get_event_conflicts&json=t&type=ajax&wizard_id=tfs_Event;events`;

  if (event.id) {
    url = `${url}&event_id=${event.id}&wizard_action=edit`;
  } else {
    url = `${url}&wizard_action=add`;
  }

  const formattedEvent = getPostFieldsToProcessEvent(event, true, checkEquipmentQuantities);
  url = `${url}&date_start=${formattedEvent.date_start}`;

  if (event.all_day) {
    url = `${url}&time_start=12:00 am&time_end=11:59 pm`;
  } else {
    if (formattedEvent.time_setup) {
      url = `${url}&time_start=${formattedEvent.time_setup}`;
    } else {
      url = `${url}&time_start=${formattedEvent.time_start}`;
    }

    if (formattedEvent.time_breakdown) {
      url = `${url}&time_end=${formattedEvent.time_breakdown}`;
    } else {
      url = `${url}&time_end=${formattedEvent.time_end}`;
    }
  }

  if (formattedEvent.date_end) {
    url = `${url}&date_end=${formattedEvent.date_end}`;
  }

  if (formattedEvent.groups && checkGroups) {
    url = `${url}&groups=${formattedEvent.groups}`;
  }

  if (formattedEvent.equipment && checkEquipment) {
    url = `${url}&equipment=${formattedEvent.equipment}`;
  }

  if (formattedEvent.hidden_locations && checkFacilities) {
    const locations = formattedEvent.hidden_locations.split(',');
    const facilities = [];

    locations.forEach((location) => {
      if (!isEmpty(location) && isString(location)) {
        const parts = location.split('_');
        if (parts[0] === 'fl') {
          facilities.push(parts[1]);
        }
      }
    });

    url = `${url}&facilities=${facilities.join(',')}`;
  }

  return {
    types: [EVENT_CONFLICT_CHECK_REQUEST, EVENT_CONFLICT_CHECK_SUCCESS, EVENT_CONFLICT_CHECK_FAILURE],
    callAPI: () => apiFetch(url, true),
    payload: { event },
  };
}

export function resetEventConflictChecks(event = {}) {
  return {
    type: EVENT_CONFLICT_CHECK_RESET,
    event,
  };
}

export function loadInbox() {
  const url = `${API_ROOT}?type=list&action=approval_my&json=t`;

  return {
    types: [INBOX_REQUEST, INBOX_SUCCESS, INBOX_FAILURE],
    id: `inbox${url}`,
    callAPI: () => apiFetch(url, true),
    onSuccess: (response, dispatch) => {
      if (has(response, 'tfs_Event')) {
        dispatch(setInboxCount(response.metadata.num_records));
      }
    },
  };
}

export function loadInboxEvent(id) {
  const url = `${API_ROOT}?type=list&action=approval_my&json=t&filter_id=${id}`;

  return {
    types: [INBOX_EVENT_REQUEST, INBOX_EVENT_SUCCESS, INBOX_EVENT_FAILURE],
    id: `inbox${url}`,
    shouldCallAPI: (store) => {
      const cached = store.inbox.byId[id];
      return !cached || shallowEqual({}, cached);
    },
    callAPI: () => apiFetch(url, true),
    payload: { id },
  };
}

export function markInboxChangeApproved(eventId, changeId, changeSetId) {
  return {
    type: INBOX_MARK_CHANGE_APPROVED,
    payload: { eventId, changeId, changeSetId },
  };
}

export function incrementEventsFilter(view, filter) {
  const today = calendar.momentFromFilter(filter);
  let newDate;

  switch (view) {
  case 'list':
  case 'month':
    newDate = today.add(1, 'month');
    break;

  case 'week':
    newDate = today.add(7, 'days');
    break;

  case 'year':
    newDate = today.add(1, 'year');
    break;

  case 'day':
  default:
    newDate = today.add(1, 'days');
    break;
  }

  return loadEvents(view, { day: newDate.format('D'), month: newDate.format('M'), year: newDate.format('YYYY') });
}

export function loadScheduleList() {
  const url = `${API_ROOT}?type=schedules&action=list&json=t`;

  return {
    types: [SCHEDULE_LIST_REQUEST, SCHEDULE_LIST_SUCCESS, SCHEDULE_LIST_FAILURE],
    id: `schedule${url}`,
    callAPI: () => apiFetch(url, true),
  };
}

export function loadScheduleView(id) {
  const url = `${API_ROOT}?type=schedules&action=view&id=${id}&json=t`;

  return {
    types: [SCHEDULE_VIEW_REQUEST, SCHEDULE_VIEW_SUCCESS, SCHEDULE_VIEW_FAILURE],
    id: `schedule${url}`,
    callAPI: () => apiFetch(url, true),
    payload: { id },
  };
}

export function loadPageList(search) {
  let url = `${API_ROOT}?type=pages&action=list&json=t`;

  if(SUBDOMAIN.length > 0) url = `${url}&subdomain=${SUBDOMAIN}`;
  if(ORGANIZATION.length > 0) url = `${url}&organization=${ORGANIZATION}`;

  if (!isEmpty(search)) {
    url += `&search=${search}`;
  }

  return {
    types: [PAGE_LIST_REQUEST, PAGE_LIST_SUCCESS, PAGE_LIST_FAILURE],
    id: `page${url}`,
    callAPI: (state) => {
      if (isEmpty(search) && !isEmpty(state.page.search)) {
        url += `&search=${state.page.search}`;
      } else if (isEmpty(search) && isEmpty(state.page.search)) {
        url += `&clear_search=1`;
      }
      return apiFetch(url, true);
    },
    payload: { search },
  };
}

export function setPageListSearch(search) {
  return {
    type: SET_PAGE_LIST_SEARCH,
    search,
  };
}

export function loadPageView(id) {
  const url = `${API_ROOT}?type=pages&action=show&id=${id}&json=t`;

  return {
    types: [PAGE_VIEW_REQUEST, PAGE_VIEW_SUCCESS, PAGE_VIEW_FAILURE],
    id: `page${url}`,
    callAPI: () => apiFetch(url, true),
    payload: { id },
  };
}

export function decrementEventsFilter(view, filter) {
  const today = calendar.momentFromFilter(filter);
  let newDate;

  switch (view) {
  case 'list':
  case 'month':
    newDate = today.subtract(1, 'month');
    break;

  case 'week':
    newDate = today.subtract(7, 'days');
    break;

  case 'year':
    newDate = today.subtract(1, 'year');
    break;

  case 'day':
  default:
    newDate = today.subtract(1, 'days');
    break;
  }

  return loadEvents(view, { day: newDate.format('D'), month: newDate.format('M'), year: newDate.format('YYYY') });
}

// Set the filter based on a `moment` object.
// Do not go fetch anything from the API
export function rawSetEventsFilter(momentDay) {
  return {
    type: SET_EVENTS_FILTER,
    filter: {
      day: momentDay.format('D'),
      month: momentDay.format('M'),
      year: momentDay.format('YYYY'),
    },
  };
}

export function setEventsSearch(search) {
  return {
    type: SET_EVENTS_SEARCH,
    search,
  };
}

export function setHeader(header = '', showBack = false, backTitle = '', rightAction = '') {
  return {
    type: SET_HEADER,
    header,
    showBack,
    backTitle,
    rightAction,
  };
}

export function routerHistoryBackAction() {
  return {
    type: ROUTER_RECORD_BACK,
  };
}

// Remove the currently visible error message.
export function removeErrorMessage() {
  return {
    type: REMOVE_ERROR_MESSAGE,
  };
}

export function setErrorMessage(message = '') {
  return {
    type: SET_ERROR_MESSAGE,
    message,
  };
}

export function setFlashMessage(message = '', messageType = 'notice') {
  return {
    type: FLASH_MESSAGE,
    message,
    messageType,
  };
}

// pass a 'message' param to only remove the flash message if it's still set to 'message'
// prevents removing a flashMessage message set by another component
export function removeFlashMessage(message = null) {
  return {
    type: REMOVE_FLASH_MESSAGE,
    message,
  };
}

export function navigationShow() {
  return {
    type: NAVIGATION_SHOW,
  };
}

export function navigationHide() {
  return {
    type: NAVIGATION_HIDE,
  };
}

export function modalVisible() {
  return {
    type: MODAL_VISIBLE,
  };
}

export function modalHidden() {
  return {
    type: MODAL_HIDDEN,
  };
}

export function loadMyTrips() {
  const url = `${API_ROOT}?type=trips&action=my_trips&json=t`;

  return {
    types: [MY_TRIPS_REQUEST, MY_TRIPS_SUCCESS, MY_TRIPS_FAILURE],
    id: `mytrips${url}`,
    callAPI: () => apiFetch(url, true)
  };
}



// WEBPACK FOOTER //
// ./src/app/actions/index.js